import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";

Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.home.length === 0) {
          store.dispatch("loadHome").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "About" */ "./views/About.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.about.length === 0) {
          store.dispatch("loadAbout").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/program",
      name: "program",
      component: () =>
        import(/* webpackChunkName: "Program" */ "./views/Program.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.program.length === 0) {
          store.dispatch("loadProgram").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/teaching",
      name: "teaching",
      component: () =>
        import(/* webpackChunkName: "Teaching" */ "./views/Teaching.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.teaching.length === 0) {
          store.dispatch("loadTeaching").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/teaching/:id",
      name: "semester",
      component: () =>
        import(/* webpackChunkName: "Semester" */ "./views/Semester.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.teaching.length === 0) {
          store.dispatch("loadTeaching").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/faculty",
      name: "faculty",
      component: () =>
        import(/* webpackChunkName: "Visiting" */ "./views/Visiting.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.visiting.length === 0) {
          store.dispatch("loadVisiting").then(() => {
            next();
          });
        }
        if (store.state.teaching.length === 0) {
          store.dispatch("loadTeaching");
        } else {
          next();
        }
      }
    },
    {
      path: "/faculty/:id",
      name: "team",
      component: () =>
        import(/* webpackChunkName: "Team" */ "./views/Team.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.visiting.length === 0) {
          store.dispatch("loadVisiting").then(() => {
            next();
          });
        }
        if (store.state.teaching.length === 0) {
          store.dispatch("loadTeaching");
        } else {
          next();
        }
      }
    },
    {
      path: "/activities",
      name: "activities",
      component: () =>
        import(/* webpackChunkName: "Activities" */ "./views/Activities.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.activities.length === 0) {
          store.dispatch("loadActivities").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: () =>
        import(/* webpackChunkName: "Contact" */ "./views/Contact.vue"),
      beforeEnter: (to, from, next) => {
        if (store.state.contact.length === 0) {
          store.dispatch("loadContact").then(() => {
            next();
          });
        } else {
          next();
        }
      }
    },
    {
      path: "*",
      redirect: "/"
    }
  ]
});
